import { Component, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { AiAcknowledgementsComponent } from "common/disclaimer/ai-acknowledgements/ai-acknowledgements.component";
import { TranslateModule } from "@ngx-translate/core";
import AiAcknowledgementsState = stages.userservice.core.AiAcknowledgementsState;

@Component({
	selector: "stages-ai-acknowledgements-popup",
	templateUrl: "./ai-acknowledgements-popup.component.html",
	styleUrls: ["./ai-acknowledgements-popup.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [AiAcknowledgementsComponent, TranslateModule],
})
export class AiAcknowledgementsPopupComponent {
	private dialog = inject(DialogAdapter);

	readonly processVersion = input.required<string>();

	readonly closeableDialog = input<boolean>(true);

	closeDialog(state: AiAcknowledgementsState): void {
		if (state && this.closeableDialog()) {
			this.dialog.close(state);
		}
	}
}
